import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./Cancel.css";
import AppBar from "../../components/AppBar";
import Footer from "../../components/Footer";
import { AuthContext } from "../../context/AuthContext";

export default function Cancel() {
  // Pull auth state from your custom auth system
  const { user, loading } = useContext(AuthContext);
  const navigate = useNavigate();

  const handlePaymentClick = () => {
    navigate("/subscribe");
  };

  const handleLoginClick = () => {
    navigate("/login");
  };

  /* -------------------------
     LOADING STATE
  --------------------------*/
  if (loading) {
    return (
      <div>
        <AppBar />
        <div style={{ height: "70px" }} />
        <div className="cancel-container">
          <div className="loading-spinner"></div>
        </div>
      </div>
    );
  }

  /* -------------------------
     NOT LOGGED IN
  --------------------------*/
  if (!user) {
    return (
      <div>
        <AppBar />
        <div style={{ height: "50px" }} />
        <div className="cancel-container">
          <h1>Not Logged In</h1>
          <p className="subtitle">Please log in to continue</p>

          <div className="cancel-details-container">
            <div className="details-section">
              <p className="error-message">
                You need to be logged in to access this page.
              </p>
              <button
                className="try-again-button"
                onClick={handleLoginClick}
              >
                Log In
              </button>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  /* -------------------------
     PAYMENT CANCELLED VIEW
  --------------------------*/
  return (
    <div>
      <AppBar />
      <div style={{ height: "70px" }} />

      <div className="cancel-container">
        <h1>Payment Cancelled</h1>
        <p className="subtitle">There was an error processing your payment</p>

        <div className="cancel-details-container">
          <h2>What happened?</h2>

          <div className="details-section">
            <p className="error-message">
              We couldn't process your payment. This could be due to:
            </p>
            <ul className="error-list">
              <li>Payment was cancelled</li>
              <li>Transaction timed out</li>
              <li>Network issues</li>
            </ul>
          </div>

          <div className="divider"></div>

          <div className="details-section">
            <p className="try-again-message">
              Don't worry! You can try again by creating a new payment.
            </p>
            <button
              className="try-again-button"
              onClick={handlePaymentClick}
            >
              Try Again
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
